import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import branchStyle from "assets/jss/material-dashboard-react/views/goldRatesStyle.js";
import "react-html5-camera-photo/build/css/index.css";
import DocumentNew from "./DocumentNew";
import DocumentOld from "./DocumentOld";
import DocumentPre from "./DocumentPre";
import DocumentRepledge from "./DocumentRepledge";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import { thirdPartyIntegrationNames } from "assets/properties/properties";
import { parseAndSetFlag } from "utils/Utils";
const useStyles = makeStyles(branchStyle);

const Document = ({
  setNext,
  setBack,
  loanApplicationId,
  loanApplicationNumber,
  props,
  editable,
  closeModal,
  status,
  newCustomer,
  existdocumentLink,
  classes,
  submitted,
  subStatus,
  loanType,
  mobileNum,
  featureFlags,
  newOrnamentsToggle,
  existingLoanData
}) => {
  const [faceLineNessEnabled,setFaceLineNessEnabled] = useState(false);
  const [faceLineNessVendor,setFaceLineNessVendor] = useState('');
  const [faceMatchEnabled,setFaceMatchEnabled] = useState(false);
  const [faceMatchVendor,setFaceMatchVendor] = useState('');
  const { authToken } = useSelector((state) => state.login.authData);
  const checkForThirdPartyFaceLivenessAndFaceMatch = parseAndSetFlag(featureFlags?.checkForThirdPartyFaceLivenessAndFaceMatch);
  
  const [logo, setLogo]=useState("")
   useEffect(()=>{
    if(parseAndSetFlag(featureFlags?.enableFaceLivelinessAndFaceMatch)){
      GetThirdPartyData()
    }else{
      GetLogoLink()
    }
    },[])
    const GetThirdPartyData = async () => {
      const result = await apiHandler({
        url: endpoint.CHECK_THIRD_PARTY_INTEGRATION,
        authToken: authToken,
      });
      if (Array.isArray(result?.data)) {
        const faceLiveNessIntegration = result.data.find(
          (integration) => integration?.integration === thirdPartyIntegrationNames?.faceLiveNess
        );
        const faceMatchIntegration = result.data.find(
          (integration) => integration?.integration === thirdPartyIntegrationNames?.faceMatch
        );
        const isFaceLiveNessEnabled = checkForThirdPartyFaceLivenessAndFaceMatch ? false : faceLiveNessIntegration?.enabled || false;
        const faceLiveNessIntegrationName  = checkForThirdPartyFaceLivenessAndFaceMatch ? "" : faceLiveNessIntegration?.vendor || '';
        const isFaceMatchEnabled = checkForThirdPartyFaceLivenessAndFaceMatch ? false : faceMatchIntegration?.enabled || false;
        const faceLiveMatchName  = checkForThirdPartyFaceLivenessAndFaceMatch ? '' : faceMatchIntegration?.vendor || '';
        setFaceLineNessVendor(faceLiveNessIntegrationName);
        setFaceLineNessEnabled(isFaceLiveNessEnabled);
        setFaceMatchEnabled(isFaceMatchEnabled);
        setFaceMatchVendor(faceLiveMatchName);
        await GetLogoLink()
      }
    };
     const GetLogoLink = async () => {
        const result = await apiHandler({
          url: endpoint.LOGO_URL,
          method: "GET",
        });
          setLogo(result?.data?.logo);
      };
 if (subStatus === "PRE_PLEDGE") {
    return (
      <DocumentPre
        classes={classes}
        status={status}
        loanApplicationId={loanApplicationId}
        loanApplicationNumber={loanApplicationNumber}
        setNext={setNext}
        setBack={setBack}
        editable={editable}
        props={props}
        closeModal={closeModal}
        existdocumentLink={existdocumentLink}
        submitted={submitted}
        newCustomer={newCustomer}
        subStatus={subStatus}
        mobileNumber={mobileNum}
        faceLineNessVendor={faceLineNessVendor}
        faceLineNessEnabled={faceLineNessEnabled}
        featureFlags={featureFlags}
        faceMatchVendor={faceMatchVendor}
        showKycFlag={faceMatchEnabled}
        logo={logo}
      />
    );
  } else if (loanType === "RE_PLEDGE") {
    return (
      <DocumentRepledge
        classes={classes}
        status={status}
        loanApplicationId={loanApplicationId}
        loanApplicationNumber={loanApplicationNumber}
        setNext={setNext}
        setBack={setBack}
        editable={editable}
        props={props}
        closeModal={closeModal}
        existdocumentLink={existdocumentLink}
        submitted={submitted}
        newCustomer={newCustomer}
        subStatus={subStatus}
        mobileNumber={mobileNum}
        faceLineNessVendor={faceLineNessVendor}
        faceLineNessEnabled={faceLineNessEnabled}
        featureFlags={featureFlags}
        faceMatchVendor={faceMatchVendor}
        showKycFlag={faceMatchEnabled}
        newOrnamentsToggle={newOrnamentsToggle}
        logo={logo}
        existingLoanData={existingLoanData}
      />
    );
  } else {
    return (
      <DocumentNew
        classes={classes}
        status={status}
        loanApplicationId={loanApplicationId}
        loanApplicationNumber={loanApplicationNumber}
        setNext={setNext}
        setBack={setBack}
        editable={editable}
        props={props}
        closeModal={closeModal}
        existdocumentLink={existdocumentLink}
        submitted={submitted}
        newCustomer={newCustomer}
        subStatus={subStatus}
        mobileNumber={mobileNum}
        faceLineNessVendor={faceLineNessVendor}
        faceLineNessEnabled={faceLineNessEnabled}
        featureFlags={featureFlags}
        faceMatchVendor={faceMatchVendor}
        showKycFlag={faceMatchEnabled}
        logo={logo}
        existingLoanData={existingLoanData}
        newLoan={loanType === "NEW"}
      />
    );
  }
};

Document.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  editable: PropTypes.object,
  closeModal: PropTypes.func,
};

export default Document;